export default "__VITE_ASSET__aik$gu7r__"